import axios from "@/axios";
import Util from "../../../../util/util";
import moment from "moment";

export const namespaced = true;

const defaultData = {
  id: 0,
  supplierName: null,
  supplierUnitOffice: null,
  supplierOrganizationId: null,
  supplierSignature: {
    signatureId: 0,
    type: "TEXT",
    text: null,
    fontFamily: null,
    edit: null,
    view: null,
  },
  supplierSignatureId: 4,
  supplierDateRequested: null,
  supplierDateSigned: null,
  organizations: [],
};

const resetData = {
  type: "TEXT",
  text: null,
  fontFamily: null,
  edit: null,
  view: null,
};

const IMAGE_EXP = "data:image\/[a-z]+;base64,";

export const state = {
  supplyOfficial: Object.assign({}, defaultData),
  helper: { countryId: 0, buySell: "" },
  status: false,
  supplyOfficialErrors: []
};

export const getters = {
  supplyOfficial: (state) => state.supplyOfficial,
  supplyOfficialErrors: (state) => state.supplyOfficialErrors,
  supplyOfficialStatus: (state) => state.status,
  supplyOfficialHelper: (state) => state.helper
};

export const mutations = {
  SET_SUPPLY_OFFICIAL_API: (state, response) => {
    // Preserve the organizations array that was loaded separately
    const currentOrganizations = state.supplyOfficial.organizations || [];
    state.supplyOfficial = Object.assign({}, state.supplyOfficial, response.data, { 
      supplierSignature: response.data.supplierSignature ? response.data.supplierSignature : defaultData.supplierSignature,
      organizations: currentOrganizations
    });

    if (state.supplyOfficial.supplierSignature.edit && !state.supplyOfficial.supplierSignature.edit.match(IMAGE_EXP)) {
      state.supplyOfficial.supplierSignature.edit = window.atob(state.supplyOfficial.supplierSignature.edit)
    }

    if (state.supplyOfficial.supplierSignature.view && !state.supplyOfficial.supplierSignature.view.match(IMAGE_EXP)) {
      state.supplyOfficial.supplierSignature.view = window.atob(state.supplyOfficial.supplierSignature.view)
    }
  },
  SET_SUPPLY_OFFICIAL_SIG: (state, response) => {
    var supplyingSig = Object.assign({}, response.data.supplierSignature ? response.data.supplierSignature : defaultData.supplierSignature);
    supplyingSig.edit = window.atob(supplyingSig.edit);
    supplyingSig.view = window.atob(supplyingSig.view);
    state.supplyOfficial.supplierSignature = supplyingSig;
  },
  SET_SUPPLY_OFFICIAL_DATA: (state, data) => {
    state.supplyOfficial = Object.assign({}, state.supplyOfficial, data)
  },
  SET_STATUS: (state, value) => (state.status = value),

  SET_HELPER: (state, value) => (state.helper = value),
  CLEAR_DATA: (state) => (state.supplyOfficial = defaultData),
  SET_ERRORS: (state, data) => (state.supplyOfficialErrors = data),
  CLEAR_ERRORS: (state) => (state.supplyOfficialErrors = []),

};

export const actions = {
  clearData({ commit }) {
    commit("CLEAR_DATA");
  },
  async getSupplyOfficialStatus({ commit }, id) {
    if (id == 0) {
      commit("SET_STATUS", false);
    } else {
      return await axios
        .get("/api/supplysignatures/status/" + id)
        .then(({ data }) => {
          if(data && data.length === 0) {
            commit("SET_STATUS", true);
            commit("CLEAR_ERRORS");
        } else {
          commit("SET_STATUS", false);
            commit("SET_ERRORS", data);
        }
        });
    }
  },
  async getSupplyOfficialHelper({ commit }, id) {
    if (id == 0) {
      commit("SET_HELPER", { countryId: 0, buySell: "" });
    } else {
      return await axios
        .get("/api/signatures/helper/" + id)
        .then(({ data }) => {
          commit("SET_HELPER", data);
        });
    }
  },

  async getSupplyOfficial({ commit, state, dispatch }, orderId) {
    try {
      commit("SET_SUPPLY_OFFICIAL_API", await axios.get(`/api/supplysignatures/${orderId}`));
    }
    catch (error) {
      console.log("ERROR LOADING SUPPLY OFFICIAL INFORMATION: ", error); //not handelled
    }
  },

  async getSupplyOfficialSigOnly({ commit, state, dispatch }, orderId) {
    try {
      commit("SET_SUPPLY_OFFICIAL_SIG", await axios.get(`/api/supplysignatures/${orderId}`));
    }
    catch (error) {
      console.log("ERROR LOADING SUPPLY OFFICIAL INFORMATION: ", error); //not handelled
    }
  },

  getCacSignature({ state, dispatch }, w) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/signatures/certificatename")
        .then(function (response) {
          const cacSignature = "data:image/jpg;base64," + response.data;
          dispatch("setSignature", cacSignature);
          return resolve();
        })
        .catch(function (error) {
          // handle error
          return reject(`There was an error getting the CAC signature...  ${error.response.data}`);
        });
    });
  },

  setSignature({ commit, state }, signature) {
    let date = null;

    if (!Util.isNullOrEmpty(signature)) {
      date = Util.convertToDateOnly(moment.utc().format("MM-DD-y HH:mm:ss"));
    }

    commit("SET_SUPPLY_OFFICIAL_DATA", { supplierSignature: Object.assign({}, state.supplyOfficial.supplierSignature, signature), supplierDateSigned: date });
  },

  async getOrganizations({ commit, state }, params) {
    try 
    {
      let response = []
      
      if (params.buySell === "SELL") {

        response = await axios.get("/api/organizations/countrycode/US");

        let organizationId = (response && response.data) ? state.supplierOrganizationId : null

        commit("SET_SUPPLY_OFFICIAL_DATA", { organizations: response.data, supplierOrganizationId: organizationId });
      } 
      
      else if (params.buySell === "BUY" && params.countryId) {

        response = await axios.get(`/api/organizations/countryid/${params.countryId}`);

        let organizationId = (response && response.data) ? state.supplierOrganizationId : null

        commit("SET_SUPPLY_OFFICIAL_DATA", { organizations: response.data, supplierOrganizationId: organizationId });
      }
      
      else if (params.buySell === "BUY" && !params.countryId) {
        // Fallback: Load all organizations if countryId is missing for BUY transactions
        response = await axios.get("/api/organizations");

        let organizationId = (response && response.data) ? state.supplierOrganizationId : null

        commit("SET_SUPPLY_OFFICIAL_DATA", { organizations: response.data, supplierOrganizationId: organizationId });
      }

      let found = response.data.find(item => item.id === state.supplyOfficial.supplierOrganizationId);

      if (params.preOrderDetailStatus && params.agreementInformationStatus && !found) {
        commit("SET_SUPPLY_OFFICIAL_DATA", { supplierOrganizationId: null });
      }
    }
    catch (error) {
      commit("SET_SUPPLY_OFFICIAL_DATA", { supplierOrganizationId: null, organizations: [] });
    }
  },

  saveSupplyOfficial({ commit, state, dispatch }, data) {
    return new Promise((resolve, reject) => {
      let supply = Object.assign({}, state.supplyOfficial, {
        supplierSignature: (!state.supplyOfficial.supplierSignature.view) ? null :
          {
            ...state.supplyOfficial.supplierSignature,
            edit: (state.supplyOfficial.supplierSignature.edit) ? window.btoa(state.supplyOfficial.supplierSignature.edit) : "",
            view: (state.supplyOfficial.supplierSignature.view) ? window.btoa(state.supplyOfficial.supplierSignature.view) : "",
          },
        supplierDateSigned: Util.convertToDateOnly(state.supplyOfficial.supplierDateSigned),
        pin: state.supplyOfficial.supplierSignature.view ? data.pin : null
      });

      axios.post("/api/supplysignatures", supply, { config: { showToast: false } })
        .then(function (response) {
          return dispatch("getSupplyOfficial", data.orderId);
        })
        .then(function () {
          return resolve();
        })
        .catch(function (error) {
          return reject(`There was an error saving Supply Official to the server...  ${error.response.data}`);
        });
    });
  }
};
